module.exports = __webpack_public_path__ + "static/media/algoexpert_logo.43707d5b.png";